export type ThemeColor =
  | "blue"
  | "sapphire"
  | "sky"
  | "cyan"
  | "seafoam"
  | "teal"
  | "mint"
  | "green"
  | "forest"
  | "lime"
  | "money"
  | "amber"
  | "orange"
  | "copper"
  | "coral"
  | "peach"
  | "red"
  | "wine"
  | "pink"
  | "fuchsia"
  | "lavender"
  | "violet"
  | "grape"
  | "indigo"
  | "navy"
  | "midnight"
  | "slate"
  | "stone";

export const THEMES: Record<
  ThemeColor,
  {
    name: string;
    light: {
      primary: string; // HSL values
      chart: string;
    };
    dark: {
      primary: string; // HSL values
      chart: string;
    };
  }
> = {
  blue: {
    name: "經典藍 (Classic Blue)",
    light: {
      primary: "221.2 83.2% 53.3%",
      chart: "221.2 83.2% 53.3%",
    },
    dark: {
      primary: "217.2 91.2% 59.8%",
      chart: "217.2 91.2% 59.8%",
    },
  },
  sapphire: {
    name: "藍寶石 (Sapphire)",
    light: {
      primary: "215 90% 42%",
      chart: "215 90% 42%",
    },
    dark: {
      primary: "213 94% 68%",
      chart: "213 94% 68%",
    },
  },
  sky: {
    name: "天空藍 (Sky)",
    light: {
      primary: "198.6 88.7% 48.4%",
      chart: "198.6 88.7% 48.4%",
    },
    dark: {
      primary: "198.6 88.7% 48.4%",
      chart: "198.6 88.7% 48.4%",
    },
  },
  cyan: {
    name: "海洋青 (Cyan)",
    light: { primary: "189 94% 39%", chart: "189 94% 39%" },
    dark: { primary: "183.2 100% 66.3%", chart: "183.2 100% 66.3%" },
  },
  seafoam: {
    name: "海沫青 (Seafoam)",
    light: {
      primary: "166 64% 36%",
      chart: "166 64% 36%",
    },
    dark: {
      primary: "166 58% 58%",
      chart: "166 58% 58%",
    },
  },
  teal: {
    name: "水鴨綠 (Teal)",
    light: {
      primary: "175.9 84.8% 32.7%",
      chart: "175.9 84.8% 32.7%",
    },
    dark: {
      primary: "168.4 82.5% 53.5%",
      chart: "168.4 82.5% 53.5%",
    },
  },
  mint: {
    name: "薄荷綠 (Mint)",
    light: {
      primary: "158 64% 36%",
      chart: "158 64% 36%",
    },
    dark: {
      primary: "156 72% 55%",
      chart: "156 72% 55%",
    },
  },
  green: {
    name: "翡翠綠 (Emerald)",
    light: {
      primary: "142.1 76.2% 36.3%",
      chart: "142.1 76.2% 36.3%",
    },
    dark: {
      primary: "142.1 70.6% 45.3%",
      chart: "142.1 70.6% 45.3%",
    },
  },
  forest: {
    name: "森林綠 (Forest)",
    light: {
      primary: "152 60% 28%",
      chart: "152 60% 28%",
    },
    dark: {
      primary: "148 48% 52%",
      chart: "148 48% 52%",
    },
  },
  lime: {
    name: "萊姆綠 (Lime)",
    light: {
      primary: "84.8 85.2% 34.5%",
      chart: "84.8 85.2% 34.5%",
    },
    dark: {
      primary: "84.8 85.2% 51.4%",
      chart: "84.8 85.2% 51.4%",
    },
  },
  money: {
    name: "財富金 (Gold)",
    light: {
      primary: "42.5 93% 43%",
      chart: "42.5 93% 43%",
    },
    dark: {
      primary: "48 96% 53%",
      chart: "48 96% 53%",
    },
  },
  amber: {
    name: "琥珀黃 (Amber)",
    light: {
      primary: "32 95% 44%",
      chart: "32 95% 44%",
    },
    dark: {
      primary: "38 92% 55%",
      chart: "38 92% 55%",
    },
  },
  orange: {
    name: "夕陽橘 (Sunset Orange)",
    light: {
      primary: "24.6 95% 53.1%",
      chart: "24.6 95% 53.1%",
    },
    dark: {
      primary: "20.5 90.2% 48.2%",
      chart: "20.5 90.2% 48.2%",
    },
  },
  copper: {
    name: "紅銅 (Copper)",
    light: {
      primary: "18 72% 42%",
      chart: "18 72% 42%",
    },
    dark: {
      primary: "22 78% 58%",
      chart: "22 78% 58%",
    },
  },
  coral: {
    name: "珊瑚橘 (Coral)",
    light: {
      primary: "6 78% 52%",
      chart: "6 78% 52%",
    },
    dark: {
      primary: "8 85% 62%",
      chart: "8 85% 62%",
    },
  },
  peach: {
    name: "蜜桃橙 (Peach)",
    light: {
      primary: "18 88% 52%",
      chart: "18 88% 52%",
    },
    dark: {
      primary: "20 90% 64%",
      chart: "20 90% 64%",
    },
  },
  red: {
    name: "熱情紅 (Red)",
    light: { primary: "0 72.2% 50.6%", chart: "0 72.2% 50.6%" },
    dark: { primary: "0 84.2% 60.2%", chart: "0 84.2% 60.2%" },
  },
  wine: {
    name: "酒紅 (Wine)",
    light: {
      primary: "345 68% 38%",
      chart: "345 68% 38%",
    },
    dark: {
      primary: "348 62% 58%",
      chart: "348 62% 58%",
    },
  },
  pink: {
    name: "櫻花粉 (Rose)",
    light: {
      primary: "346.8 77.2% 49.8%",
      chart: "346.8 77.2% 49.8%",
    },
    dark: {
      primary: "343.4 81.3% 56.4%",
      chart: "343.4 81.3% 56.4%",
    },
  },
  fuchsia: {
    name: "時尚紫 (Fuchsia)",
    light: {
      primary: "292.2 84.1% 42.9%",
      chart: "292.2 84.1% 42.9%",
    },
    dark: {
      primary: "292.2 84.1% 60.6%",
      chart: "292.2 84.1% 60.6%",
    },
  },
  lavender: {
    name: "薰衣草紫 (Lavender)",
    light: {
      primary: "258 55% 55%",
      chart: "258 55% 55%",
    },
    dark: {
      primary: "258 70% 72%",
      chart: "258 70% 72%",
    },
  },
  violet: {
    name: "紫羅蘭 (Violet)",
    light: {
      primary: "262.1 83.3% 57.8%",
      chart: "262.1 83.3% 57.8%",
    },
    dark: {
      primary: "263.4 70% 50.4%",
      chart: "263.4 70% 50.4%",
    },
  },
  grape: {
    name: "葡萄紫 (Grape)",
    light: {
      primary: "271 68% 42%",
      chart: "271 68% 42%",
    },
    dark: {
      primary: "270 70% 68%",
      chart: "270 70% 68%",
    },
  },
  indigo: {
    name: "深邃靛 (Indigo)",
    light: {
      primary: "243.4 75.4% 58.6%",
      chart: "243.4 75.4% 58.6%",
    },
    dark: {
      primary: "244.7 85% 70%",
      chart: "244.7 85% 70%",
    },
  },
  navy: {
    name: "海軍藍 (Navy)",
    light: {
      primary: "222 55% 32%",
      chart: "222 55% 32%",
    },
    dark: {
      primary: "217 70% 68%",
      chart: "217 70% 68%",
    },
  },
  midnight: {
    name: "午夜藍 (Midnight)",
    light: {
      primary: "224 42% 24%",
      chart: "224 42% 24%",
    },
    dark: {
      primary: "220 45% 72%",
      chart: "220 45% 72%",
    },
  },
  slate: {
    name: "極簡灰 (Slate)",
    light: { primary: "215.4 16.3% 36.9%", chart: "215.4 16.3% 36.9%" },
    dark: { primary: "210 40% 98%", chart: "210 40% 98%" },
  },
  stone: {
    name: "暖石灰 (Stone)",
    light: {
      primary: "30 8% 38%",
      chart: "30 8% 38%",
    },
    dark: {
      primary: "30 10% 78%",
      chart: "30 10% 78%",
    },
  },
};

/** Swatches for the settings picker — hue-ordered, two-row horizontal scroll. */
export const THEME_SWATCHES: { id: ThemeColor; value: string; label: string }[] = [
  { id: "blue", value: "#2563eb", label: "經典藍" },
  { id: "sapphire", value: "#0b6bcb", label: "藍寶石" },
  { id: "sky", value: "#0ea5e9", label: "天空藍" },
  { id: "cyan", value: "#0891b2", label: "海洋青" },
  { id: "seafoam", value: "#218c78", label: "海沫青" },
  { id: "teal", value: "#0d9488", label: "水鴨綠" },
  { id: "mint", value: "#219a74", label: "薄荷綠" },
  { id: "green", value: "#059669", label: "翡翠綠" },
  { id: "forest", value: "#1c6b4a", label: "森林綠" },
  { id: "lime", value: "#65a30d", label: "萊姆綠" },
  { id: "money", value: "#ca8a04", label: "財富金" },
  { id: "amber", value: "#d97706", label: "琥珀黃" },
  { id: "orange", value: "#f97316", label: "夕陽橘" },
  { id: "copper", value: "#b85c2e", label: "紅銅" },
  { id: "coral", value: "#e54d3d", label: "珊瑚橘" },
  { id: "peach", value: "#f07a3a", label: "蜜桃橙" },
  { id: "red", value: "#dc2626", label: "熱情紅" },
  { id: "wine", value: "#a31d45", label: "酒紅" },
  { id: "pink", value: "#e11d70", label: "櫻花粉" },
  { id: "fuchsia", value: "#c026d3", label: "時尚紫" },
  { id: "lavender", value: "#8b6fd4", label: "薰衣草紫" },
  { id: "violet", value: "#7c3aed", label: "紫羅蘭" },
  { id: "grape", value: "#7a32b3", label: "葡萄紫" },
  { id: "indigo", value: "#4f46e5", label: "深邃靛" },
  { id: "navy", value: "#253a6b", label: "海軍藍" },
  { id: "midnight", value: "#232a4a", label: "午夜藍" },
  { id: "slate", value: "#475569", label: "極簡灰" },
  { id: "stone", value: "#6b655c", label: "暖石灰" },
];

export const DEFAULT_THEME_COLOR: ThemeColor = "sky";
